import React from 'react'
import { Grid, TextField, Button, InputAdornment, makeStyles, useTheme, useMediaQuery } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import ExportMenu from '../ExportMenu'
import AddIcon from '@material-ui/icons/Add';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		padding: theme.spacing(0.5, 0),
	},
	searchGrid: {
		[theme.breakpoints.down('xs')]: {
			marginBottom: theme.spacing(1),
		},
	},
	searchField: {
		'& .MuiOutlinedInput-root': {
			fontSize: 12,
			[theme.breakpoints.down('xs')]: {
				fontSize: 13,
			},
		},
	},
	actionsGrid: {
		display: 'flex',
		alignItems: 'center',
		[theme.breakpoints.down('xs')]: {
			justifyContent: 'center',
		},
		[theme.breakpoints.up('sm')]: {
			justifyContent: 'flex-end',
		},
	},
	actionsList: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 6,
		margin: 0,
		padding: 0,
		listStyle: 'none',
		[theme.breakpoints.down('xs')]: {
			justifyContent: 'center',
			width: '100%',
		},
		[theme.breakpoints.between('sm', 'md')]: {
			justifyContent: 'flex-end',
		},
		[theme.breakpoints.up('md')]: {
			justifyContent: 'flex-end',
		},
	},
	actionItem: {
		[theme.breakpoints.down('xs')]: {
			flexGrow: 1,
			minWidth: 'calc(50% - 6px)',
			maxWidth: 'calc(50% - 6px)',
			'& button, & > div': {
				width: '100%',
			},
		},
		[theme.breakpoints.between('sm', 'sm')]: {
			flexShrink: 0,
		},
		[theme.breakpoints.up('md')]: {
			flexShrink: 0,
		},
	},
}))


const CtaAction = ({ searchPlaceholder, onSearch, permissionCheck, addLabel, onAddFn, onImportFn, exportMenu, downloadSampleMenu }) => {
	const classes = useStyles()
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

	return (
		<Grid container spacing={1} className={classes.root} alignItems='center'>
			<Grid item xs={12} sm={12} md={5} className={classes.searchGrid}>
				<TextField
					variant='outlined'
					fullWidth
					size='small'
					placeholder={searchPlaceholder || 'Search'}
					className={classes.searchField}
					onChange={(e) => onSearch && onSearch(e.target.value)}
					InputProps={{
						style: { fontSize: 12 },
						endAdornment: (
							<InputAdornment position='end'>
								<SearchIcon color='primary' style={{ cursor: 'pointer' }} />
							</InputAdornment>
						),
					}}
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={7} className={classes.actionsGrid}>
				<ul className={classes.actionsList}>
					{!permissionCheck && downloadSampleMenu && (
						<li className={classes.actionItem}>
							<ExportMenu
								exportReportFn={downloadSampleMenu?.exportReportFn}
								files={downloadSampleMenu?.files}
								title={<>{isMobile ? 'SAMPLE' : 'DOWNLOAD SAMPLE'}<KeyboardArrowDownIcon style={{ marginTop: "-1px" }} /></>}
							/>
						</li>
					)}
					{exportMenu && (
						<li className={classes.actionItem}>
							<ExportMenu
								exportReportFn={exportMenu.exportReportFn}
								files={exportMenu?.files}
								disabled={exportMenu?.disabled}
								title='EXPORT'
							/>
						</li>
					)}
					{!permissionCheck && onImportFn && (
						<li className={classes.actionItem}>
							<Button fullWidth variant='outlined' color='primary' size='small' onClick={onImportFn}>
								<AddIcon style={{ fontSize: '1.15rem', marginTop: '-1px' }} />IMPORT
							</Button>
						</li>
					)}
					{!permissionCheck && (
						<li className={classes.actionItem}>
							<Button fullWidth variant='contained' color='primary' size='small' onClick={onAddFn}>
								<AddIcon style={{ fontSize: '1.15rem', marginTop: '-1px' }} /> {isMobile ? ('ADD') : (addLabel || 'ADD')}
							</Button>
						</li>
					)}
				</ul>
			</Grid>
		</Grid>
	)
}

export default CtaAction
